/**
 * Background Size enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BACKGROUND_SIZE {
	CONTAIN = "contain",
	COVER = "cover"
}

export type BACKGROUND_SIZE_string = keyof typeof BACKGROUND_SIZE;

export const BACKGROUND_SIZE_default: BACKGROUND_SIZE_string = "CONTAIN";
